import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const LorryHireChallanNewPage = lazy(() => import("@/pages/lorry-hire-challans.new.page"));

export const Route = createFileRoute("/lorry-hire-challans/new")({
  component: LorryHireChallanNewPage,
  validateSearch: (search: Record<string, unknown>): { challanId?: string } => ({
    challanId: typeof search.challanId === "string" ? search.challanId : undefined,
  }),
});
